<template>
    <div class="message-box">
        <header>
            <h1>通知中心</h1>
        </header>
        <template v-if="list.length != 0">
            <ul>
                <li class="title-of-notice" v-for="item in list" :key="item.sys_id">
                    <div class="flag-of-read read"></div>
                    <div class="col-of-title" v-html="item.sys_content"></div>
                    <div class="col-of-date">{{ item.notice_time | timestampToYMD}}</div>
                </li>
                <el-pagination layout="prev, pager, next" :page-size="page_size" :current-page="page" :total="total"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </ul>

        </template>
        <template v-else>
            <div class="no-data">暂无数据</div>
        </template>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [],
            page_size: 17,
            page: 1,
            total: 0
        }
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.$axios.post(this.$ApiInfo.getSysnotice, "data=" + JSON.stringify({ page_size: this.page_size, page: this.page }), false).then(res => {
                this.list = res.pageList;
                this.total = res.allCapacity
            })
        },
        handleCurrentChange(v) {
            this.page = v;
            this.getList();
        }
    },
    filters: {
        timestampToYMD(timestamp) {
            var date = new Date(timestamp);

            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString().padStart(2, '0'); 
            var day = date.getDate().toString().padStart(2, '0'); 

            return `${year}/${month}/${day}`;
        }
    }
}
</script>
<style lang="less">
.message-box {
    min-height: 500px;
    background-color: #fff;

    header {
        line-height: 70px;
        height: 55px;
        background-color: #e8faff;
        width: 100%;
        border-bottom: 2px solid #eaeaea;
    }

    h1 {
        margin-left: 35px;
        font-size: 18px;
        line-height: 55px;
        font-weight: 400;
        font-family: "Microsoft Yahei";
    }

    .no-data {
        height: calc(500px - 55px);
        line-height: calc(500px - 55px);
        text-align: center;
        font-size: 24px;
    }

    .el-pagination {
        margin: 20px 0;
        display: flex;
        justify-content: center;
    }

    ul {
        .title-of-notice {
            font-size: 15px;
            position: relative;
            width: 100%;
            max-width: 100%;
            border-bottom: 1px solid #f1f1f1;

            .col-of-title {
                max-width: 960px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding-right: 138px;
                display: inline-block;
                border-top: none;
                color: #585858;
                font-size: 15px;
                vertical-align: middle;
                padding: 8px;
            }

            .col-of-date {
                position: absolute;
                right: 35px;
                top: 0;
                width: 200px;
                text-align: right;
                margin-right: 15px;
                display: inline-block;
                border-top: none;
                color: #585858;
                font-size: 15px;
                vertical-align: middle;
                padding: 8px;
            }

            .flag-of-read {
                box-sizing: border-box;
                display: inline-block;
                border-top: none;
                vertical-align: middle;
                color: #ccc;
                background-color: #ccc;
                padding: 3px;
                margin-left: 35px;
                width: 5px;
                height: 5px;
                border-radius: 50%;

                &.read {
                    color: #2AB5E2;
                    background-color: #2AB5E2;
                }

                &.unread {
                    color: #ccc;
                    background-color: #ccc;
                }

            }
        }
    }

}
</style>